"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateTPAParamsWithMetadata = exports.generateTPAParams = exports.generateTPAParamsFromStyleParams = exports.getSiteLevelStyles = void 0;
var tpa_settings_1 = require("@wix/tpa-settings");
var resolvers_1 = require("@wix/editor-platform-ooi-metadata-resolver/resolvers");
var utils_1 = require("./utils/utils");
var wixStyleFontUtils_1 = require("./utils/wixStyleFontUtils");
var wixStylesColorUtils_1 = require("./utils/wixStylesColorUtils");
var constants_1 = require("./constants");
var cloneStyleParams = function (styleParams) {
    return __assign(__assign({}, styleParams), { numbers: __assign({}, styleParams.numbers), booleans: __assign({}, styleParams.booleans), fonts: __assign({}, styleParams.fonts), colors: __assign({}, styleParams.colors), strings: __assign({}, styleParams.strings) });
};
function overrideStyleParamsWithDefaults(_a) {
    var _b;
    var styles = _a.styles, defaults = _a.defaults, siteThemeVars = _a.siteThemeVars, options = _a.options;
    var styleParamsWithDefaults = cloneStyleParams(styles.styleParams);
    var styleParamsWithMetadataDefaults = {};
    if (!defaults) {
        return { styleParamsWithDefaults: styleParamsWithDefaults, styleParamsWithMetadataDefaults: styleParamsWithMetadataDefaults };
    }
    var getParam = (0, tpa_settings_1.createStoredStyleParamGetter)({
        storage: styleParamsWithDefaults,
        isMobile: options.isMobile,
        styleParamsPerBreakpointMode: options.usesCssPerBreakpoint,
    });
    var getDefaultValue = (0, tpa_settings_1.createStyleParamDefaultValueGetter)({
        styles: styleParamsWithDefaults,
        textPresets: styles.siteTextPresets,
        colors: styles.siteColors,
        dimensions: options.dimensions,
        options: {
            isMobile: options.isMobile,
            isRTL: options.isRTL,
            isEditorX: options.isEditorX,
            styleParamsPerBreakpointMode: options.usesCssPerBreakpoint,
        },
    });
    var styleParamsMap = (_b = {},
        _b[tpa_settings_1.StyleParamType.Number] = styleParamsWithDefaults.numbers,
        _b[tpa_settings_1.StyleParamType.Boolean] = styleParamsWithDefaults.booleans,
        _b[tpa_settings_1.StyleParamType.Font] = styleParamsWithDefaults.fonts,
        _b[tpa_settings_1.StyleParamType.Color] = styleParamsWithDefaults.colors,
        _b[tpa_settings_1.StyleParamType.String] = styleParamsWithDefaults.strings,
        _b);
    Object.keys(defaults).forEach(function (styleKey) {
        var styleParam = defaults[styleKey];
        // tslint:disable-next-line:deprecation
        var keyWithoutTraits = styleParam.key || styleParam.name;
        var targetStylesMap = styleParamsMap[styleParam.type];
        var paramValue = getParam(styleParam);
        if (paramValue !== undefined) {
            targetStylesMap[keyWithoutTraits] = paramValue;
        }
        else {
            if (options.usesBuilderModel && styleParam.metadata) {
                try {
                    var metadataDefaultValue = (0, resolvers_1.resolveDefaultValue)({
                        metadata: styleParam.metadata,
                        params: defaults,
                        isMobile: options.isMobile,
                        t: function () { return ''; },
                    });
                    var cssValue = (0, resolvers_1.resolveStyleCSSValue)(metadataDefaultValue, { themeVariables: siteThemeVars });
                    styleParamsWithMetadataDefaults[keyWithoutTraits] = { type: metadataDefaultValue.type, cssValue: cssValue };
                }
                catch (e) { }
            }
            else {
                var defaultValue = getDefaultValue(styleParam);
                if (typeof defaultValue != 'undefined') {
                    targetStylesMap[keyWithoutTraits] = defaultValue;
                }
            }
        }
    });
    return { styleParamsWithDefaults: styleParamsWithDefaults, styleParamsWithMetadataDefaults: styleParamsWithMetadataDefaults };
}
function getSiteLevelStyles(siteColors, siteTextPresets) {
    var colors = wixStylesColorUtils_1.wixStylesColorUtils.getFullColorStyles({ colorStyles: {}, siteColors: siteColors }) || {};
    var fonts = wixStyleFontUtils_1.wixStylesFontUtils.getFullFontStyles({ fontStyles: {}, siteTextPresets: siteTextPresets }) || {};
    return { colors: colors, fonts: fonts };
}
exports.getSiteLevelStyles = getSiteLevelStyles;
function generateTPAParamsFromStyleParams(styleParams, siteColors, siteTextPresets, options) {
    var _a;
    var _b;
    if (options === void 0) { options = {}; }
    var colorStyles = styleParams.colors;
    var fontStyles = (0, utils_1.pickBy)(styleParams.fonts, wixStyleFontUtils_1.wixStylesFontUtils.isValidFontParam);
    var numbers = styleParams.numbers || {};
    var colors = wixStylesColorUtils_1.wixStylesColorUtils.getFullColorStyles({ colorStyles: colorStyles, siteColors: siteColors }) || {};
    var fonts = wixStyleFontUtils_1.wixStylesFontUtils.getFullFontStyles({ fontStyles: fontStyles, siteTextPresets: siteTextPresets }) || {};
    var strings = __assign(__assign({}, (0, utils_1.pickBy)(styleParams.fonts, wixStyleFontUtils_1.wixStylesFontUtils.isStringHack)), ((_b = styleParams.strings) !== null && _b !== void 0 ? _b : {}));
    var booleans = __assign(__assign({}, styleParams.booleans), (_a = {}, _a[constants_1.IS_RTL_PARAM] = options.isRTL, _a));
    return { colors: colors, fonts: fonts, numbers: numbers, strings: strings, booleans: booleans };
}
exports.generateTPAParamsFromStyleParams = generateTPAParamsFromStyleParams;
function generateTPAParams(_a) {
    var siteColors = _a.siteColors, siteTextPresets = _a.siteTextPresets, styleParams = _a.styleParams, options = _a.options, defaults = _a.defaults;
    var styleParamsWithDefaults = overrideStyleParamsWithDefaults({
        styles: {
            siteColors: siteColors,
            siteTextPresets: siteTextPresets,
            styleParams: styleParams,
        },
        defaults: defaults,
        options: options,
    }).styleParamsWithDefaults;
    return generateTPAParamsFromStyleParams(styleParamsWithDefaults, siteColors, siteTextPresets, options);
}
exports.generateTPAParams = generateTPAParams;
function generateTPAParamsWithMetadata(_a) {
    var siteColors = _a.siteColors, siteTextPresets = _a.siteTextPresets, styleParams = _a.styleParams, options = _a.options, defaults = _a.defaults, siteThemeVars = _a.siteThemeVars;
    var _b = overrideStyleParamsWithDefaults({
        styles: {
            siteColors: siteColors,
            siteTextPresets: siteTextPresets,
            styleParams: styleParams,
        },
        defaults: defaults,
        options: options,
        siteThemeVars: siteThemeVars,
    }), styleParamsWithDefaults = _b.styleParamsWithDefaults, styleParamsWithMetadataDefaults = _b.styleParamsWithMetadataDefaults;
    return {
        tpaParams: generateTPAParamsFromStyleParams(styleParamsWithDefaults, siteColors, siteTextPresets, options),
        styleParamsWithMetadataDefaults: styleParamsWithMetadataDefaults,
    };
}
exports.generateTPAParamsWithMetadata = generateTPAParamsWithMetadata;
//# sourceMappingURL=generateTPAParams.js.map